import { motion } from 'framer-motion';

export default function Manifesto() {
  return (
    <section
      data-testid="manifesto-section"
      className="relative paper-kraft text-[#1F1F1F] py-24 md:py-40 overflow-hidden"
    >
      <div className="grain" />

      {/* Sol üst köşe */}
      <div className="absolute top-8 md:top-12 left-6 md:left-10 z-10">
        <span className="eyebrow text-[#B03A2E]">— Manifesto</span>
      </div>

      {/* Sağ üst köşe */}
      <div className="absolute top-8 md:top-12 right-6 md:right-10 z-10 flex items-center gap-2">
        <span className="w-8 h-px bg-[#B03A2E]" />
        <span className="eyebrow text-[#B03A2E]">Amasra · Karadeniz</span>
      </div>

      {/* Dekoratif çember arka planda */}
      <div
        className="absolute -right-40 top-1/2 -translate-y-1/2 w-[520px] h-[520px] rounded-full border border-[#B08834]/20 hidden lg:block"
        aria-hidden
      />
      <div
        className="absolute -left-40 top-1/3 w-[380px] h-[380px] rounded-full border border-[#B03A2E]/15 hidden lg:block"
        aria-hidden
      />

      <div className="max-w-[1400px] mx-auto px-6 md:px-10 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        >
          <h2 className="font-display text-[12vw] md:text-[8.5vw] lg:text-[7rem] xl:text-[8.5rem] leading-[0.98] tracking-[-0.02em] font-light">
            <span className="block">Sofranız</span>
            <span className="block italic text-[#B08834]">bir hikaye</span>
            <span className="block">anlatsın.</span>
            <span className="block italic text-[#B03A2E] mt-6 text-[9vw] md:text-[6.5vw] lg:text-[5rem] xl:text-[6.2rem] leading-[1.05]">
              Karadeniz&apos;den, katkısız, dürüst bir hikaye.
            </span>
          </h2>
        </motion.div>
      </div>
    </section>
  );
}
